import type { PdfCanvasStroke, PdfCanvasStrokeDrawScale } from "./pdfCanvasTypes";

export type { PdfCanvasStrokeDrawScale } from "./pdfCanvasTypes";

const DEFAULT_STROKE_SCALE: PdfCanvasStrokeDrawScale = { scaleX: 1, scaleY: 1 };

export function drawStrokeOnContext(
    ctx: CanvasRenderingContext2D,
    stroke: PdfCanvasStroke,
    scale: PdfCanvasStrokeDrawScale = DEFAULT_STROKE_SCALE,
): void {
    if (stroke.points.length === 0) {
        return;
    }

    const scaleFactor = Math.max(scale.scaleX, scale.scaleY);
    ctx.save();
    ctx.globalCompositeOperation = stroke.tool === "erase" ? "destination-out" : "source-over";
    ctx.strokeStyle = stroke.color;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.globalAlpha = stroke.tool === "erase" ? 1 : 0.65;
    ctx.lineWidth = stroke.radius * scaleFactor * 2;
    ctx.beginPath();
    ctx.moveTo(stroke.points[0].x * scale.scaleX, stroke.points[0].y * scale.scaleY);
    for (let i = 1; i < stroke.points.length; i++) {
        ctx.lineTo(stroke.points[i].x * scale.scaleX, stroke.points[i].y * scale.scaleY);
    }
    ctx.stroke();
    ctx.restore();
}

export function drawStrokesOnContext(
    ctx: CanvasRenderingContext2D,
    strokes: PdfCanvasStroke[],
    scale: PdfCanvasStrokeDrawScale = DEFAULT_STROKE_SCALE,
): void {
    for (const stroke of strokes) {
        drawStrokeOnContext(ctx, stroke, scale);
    }
}
